import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import uiDux from 'src/redux/ui';
import FooterAddress from './FooterAddress';
import FooterLogo from './FooterLogo';
import 'pepjs';

import { FooterContainer } from './styled';

export const mapStateToProps = ({ designPro }) => ({
  isSidebarOpen: designPro.ui.isSidebarOpen,
  shouldRenderFooter: uiDux.selectors.shouldRenderFooter({
    designPro,
  }),
});

export class Footer extends PureComponent {
  static propTypes = {
    shouldRenderFooter: PropTypes.bool.isRequired,
    isSidebarOpen: PropTypes.bool.isRequired,
  };

  render() {
    const { shouldRenderFooter, isSidebarOpen } = this.props;

    return (
      <FooterContainer
        isDisplayed={shouldRenderFooter}
        isSidebarOpen={isSidebarOpen}
      >
        <div touch-action="none">
          {/* Prevent zoom on touch devices. Also note, touch-action is incompatible with styled and React components (see NS-947) */}
          <FooterLogo />
          <FooterAddress />
        </div>
      </FooterContainer>
    );
  }
}

export default connect(mapStateToProps)(Footer);
